import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import { Link } from 'gatsby'
import React, { memo } from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

export interface Props {
  image?: ImageProps
  label?: string
  title?: string
  URL: string
}

export const Item = memo(function Item({ image, label, title, URL }: Props) {
  if (!URL) {
    return null
  }

  return (
    <Container to={URL}>
      {image ? (
        <LazyLoadComponent>
          <Image {...image} />
        </LazyLoadComponent>
      ) : null}
      <Wrapper>
        <Content className="banner-content">
          {label ? <Label>{label}</Label> : null}
          {title ? <Title>{title}</Title> : null}
        </Content>
      </Wrapper>
    </Container>
  )
})

const Container = styled(Link)`
  width: 50%;
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  overflow: hidden;
  padding-bottom: 28%;
  position: relative;
  text-align: center;
  &:hover {
    img {
      transform: scale(1.1);
    }
    .banner-content {
      @media (min-width: 768px) {
        background: #53a78b;
        border-color: transparent;
      }
    }
  }
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    background: ${({ theme }) => theme.colors.variants.neutralDark4};
    opacity: 0.4;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
  }

  img {
    width: 101%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.25s ease-in-out;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-top: 0.9375rem;
    padding-bottom: 50%;
    &:first-of-type {
      margin-top: 0;
    }
  }
`

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  z-index: 2;
  transform: translateY(-50%);
`

const Content = styled.div`
  width: calc(100% - 22.5vw);
  min-width: 440px;
  border: 2px solid ${({ theme }) => theme.colors.variants.neutralLight4};
  margin: auto;
  padding: 3.5rem 30px;
  transition: background 0.3s ease-in-out, border 0.3s ease-in-out;

  @media (max-width: 1200px) {
    width: 70%;
    min-width: unset;
  }

  @media (max-width: 1023px) {
    width: 75%;
  }

  @media (max-width: 767px) {
    width: 100%;
    border: 0;
    padding: 0 1.25rem;
  }
`

const Label = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-weight: 500;
  font-size: 1.8125rem;
  text-align: center;
`

const Title = styled.div`
  margin-top: 10px;
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;
`
